export const reportsApi = (client) => ({
    mttrMtbf: (params) => client.get('/api/v1/reports/mttr-mtbf', { params }).then((r) => r.data),
    pmCompliance: (params) => client.get('/api/v1/reports/pm-compliance', { params }).then((r) => r.data),
    slaCompliance: (params) => client.get('/api/v1/reports/sla-compliance', { params }).then((r) => r.data),
    costAnalysis: (params) => client.get('/api/v1/reports/cost-analysis', { params }).then((r) => r.data),
    backlog: () => client.get('/api/v1/reports/backlog').then((r) => r.data),
    woVolume: (params) => client.get('/api/v1/reports/wo-volume', { params }).then((r) => r.data),
});
//# sourceMappingURL=reports.js.map